class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    // リサイズイベントを監視して、位置を更新
    this.resizeHandler = this.updatePosition.bind(this);
    window.addEventListener('resize', this.resizeHandler);

    // スクロールイベントを監視して、位置を更新（スティッキーヘッダーの位置変化に対応）
    this.scrollHandler = this.updatePosition.bind(this);
    window.addEventListener('scroll', this.scrollHandler, { passive: true });
  }

  open() {
    this.notification.classList.add('animate', 'active');

    // ウィンドウサイズが989px以下の時に、headerの下に配置
    this.updatePosition();

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  updatePosition() {
    if (window.innerWidth <= 989) {
      // アナウンスバーの要素を取得
      const announcementBar = document.querySelector('.announcement-bar-section') || document.querySelector('.utility-bar');
      let announcementBarHeight = 0;

      if (announcementBar) {
        // アナウンスバーが表示されているかチェック
        const computedStyle = window.getComputedStyle(announcementBar);
        if (computedStyle.display !== 'none' && computedStyle.visibility !== 'hidden') {
          // アナウンスバーの位置を取得（スクロール位置を考慮）
          const announcementBarRect = announcementBar.getBoundingClientRect();
          // アナウンスバーが画面内に表示されている場合のみ高さを考慮
          // announcementBarRect.topが0以上の場合、アナウンスバーは画面内に表示されている
          if (announcementBarRect.top >= 0 && announcementBarRect.bottom > 0) {
            announcementBarHeight = announcementBar.offsetHeight;
          }
        }
      }

      // headerの高さを取得
      const headerElement = document.querySelector('.section-header') || document.querySelector('header');
      let headerHeight = 0;

      if (headerElement) {
        headerHeight = headerElement.offsetHeight;
      } else {
        // CSS変数から取得を試みる
        const headerHeightVar = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
        if (headerHeightVar) {
          headerHeight = parseFloat(headerHeightVar);
        }
      }

      // アナウンスバーの高さ（表示されている場合のみ）とheaderの高さを合計
      const totalTop = announcementBarHeight + headerHeight;

      // position: fixed と top の値を設定
      this.notification.style.position = 'fixed';
      this.notification.style.top = `${totalTop}px`;
    } else {
      // 989pxより大きい場合は、デフォルトのスタイルに戻す
      this.notification.style.position = '';
      this.notification.style.top = '';
    }
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = document.getElementById(section.id);
      const sectionHTML = parsedState.sections[section.id];

      // セクションHTMLが存在し、要素が存在する場合のみ更新
      if (sectionElement && sectionHTML) {
        const innerHTML = this.getSectionInnerHTML(sectionHTML, section.selector);
        if (innerHTML !== null) {
          sectionElement.innerHTML = innerHTML;
        }
      }
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'header',
        selector: '#mobile-cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (!html) return null;
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const element = parsed.querySelector(selector);
    return element ? element.innerHTML : null;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  disconnectedCallback() {
    // リサイズイベントリスナーを削除
    window.removeEventListener('resize', this.resizeHandler);
    // スクロールイベントリスナーを削除
    window.removeEventListener('scroll', this.scrollHandler);
  }
}

customElements.define('cart-notification', CartNotification);
